import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { RecoilRoot } from "recoil";
import MyContextStore from "./context/myContext";
import { BrowserRouter } from "react-router-dom";
import { ModuleRegistry } from "@ag-grid-community/core";
import "@ag-grid-enterprise/core";
import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model";
import { SetFilterModule } from "@ag-grid-enterprise/set-filter";
import { FiltersToolPanelModule } from '@ag-grid-enterprise/filter-tool-panel';
import { MultiFilterModule } from "@ag-grid-enterprise/multi-filter";
import { ExcelExportModule } from '@ag-grid-enterprise/excel-export';
import { CsvExportModule } from '@ag-grid-community/csv-export';
import "@ag-grid-community/styles/ag-grid.css";
import "@ag-grid-community/styles/ag-theme-alpine.css";
import { LicenseManager } from "@ag-grid-enterprise/core";
import { MasterDetailModule } from '@ag-grid-enterprise/master-detail';
import { ClipboardModule } from '@ag-grid-enterprise/clipboard';
import { MenuModule } from '@ag-grid-enterprise/menu';

const root = ReactDOM.createRoot(document.getElementById("root"));

const ag_grid_license_key =
  "Using_this_{AG_Grid}_Enterprise_key_{AG-054349}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{TalentSavvy.com}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{Team_Management_Solution}_only_for_{3}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_working_on_{Team_Management_Solution}_need_to_be_licensed___{Team_Management_Solution}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{2_March_2025}____[v3]_[01]_MTc0MDg3MzYwMDAwMA==5c17474c07628e9f89147fbd392482ce";

LicenseManager.setLicenseKey(ag_grid_license_key);

// Register the required feature modules with the Grid
ModuleRegistry.registerModules([
  ClientSideRowModelModule,
  CsvExportModule,
  ExcelExportModule,
  SetFilterModule,
  MultiFilterModule,
  FiltersToolPanelModule,
  MenuModule,
  ClipboardModule,
  MasterDetailModule
]);

root.render(
  <RecoilRoot>
    <React.StrictMode>
    <BrowserRouter>
      <MyContextStore>
        <App />
      </MyContextStore>
      </BrowserRouter>
    </React.StrictMode>
  </RecoilRoot>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
